// Dates are rendered both on the server (UTC) and in the browser (visitor's
// zone); formatting in a fixed zone keeps both renders identical and shows
// Bishkek time to every visitor.
export const SITE_TIME_ZONE = 'Asia/Bishkek'

// Some endpoints (e.g. /organizations/rates) return naive "YYYY-MM-DD HH:mm:ss"
// strings that are already in Bishkek time (UTC+6, no DST). Without an explicit
// offset they would be read in the server's or the visitor's own zone.
const NAIVE_DATE_TIME = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/

export const parseSiteDate = (inputDate: string) =>
  new Date(NAIVE_DATE_TIME.test(inputDate) ? `${inputDate.replace(' ', 'T')}+06:00` : inputDate)

export const useDateFormat = (inputDate: string) => {
  const date = parseSiteDate(inputDate)

  return date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: SITE_TIME_ZONE
  })
}

export const useTimeFormat = (inputDate: string) => {
  const date = parseSiteDate(inputDate)

  return date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: SITE_TIME_ZONE
  })
}

export const useDateTimeFormat = (inputDate: string) => {
  const date = parseSiteDate(inputDate)

  return `${date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: SITE_TIME_ZONE
  })}, ${date.toLocaleDateString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: SITE_TIME_ZONE
  })}`
}
